import { useEffect } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { SidebarProvider } from "../../Context/SidebarContext";
import Loader from "../../components/Loader";
import {
  useGetAttributesValuesQuery,
  useGetProductsQuery,
} from "../../redux/api/productsApi.js";
import BodyContent from "./BodyContent";
import ProductsTable from "./ProductsTable";
import SidebarCategory from "../Category/SidbarCategory";
import InlineAttributesFilter from "../Category/InlineAttributesFilter";
import ResultsShownFilter from "./ResultsShownFilter";
import CategoryNav from "./CategoryNav";
import { toast } from "react-hot-toast";

// Pagination
import CustomPagination from "../../components/layout/CustomPagination";
import { useNavigate, useSearchParams } from "react-router-dom";


import {
  useGetparentCategoryQuery,
  useGetSubCategoryQuery,
} from "../../redux/api/categoryApi";

import MetaData from "../../components/layout/MetaData";
import { parseProductAttributesParam } from "../../utils/similarProducts";



/**
 * 渲染商品列表页，并支持分类、关键字和相似产品属性筛选。
 * @returns {React.JSX.Element} 商品列表页
 */
const ProductsPage = () => {
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const page = Number(searchParams.get("page")) || 1;
  const select = Number(searchParams.get("select"));
  const keyword = searchParams.get("keyword") || "";
  const params = { page, keyword, select };

  //TODO: check if category is not null and add it to params object
  const category = searchParams.get("category");
  category !== null && (params.category = category);
  const supCategory = searchParams.get("sup_category");
  supCategory !== null && (params.sup_category = supCategory);
  const productAttributesParam = searchParams.get("product_Attributes");
  const similarProductFilters = parseProductAttributesParam(productAttributesParam);
  productAttributesParam !== null && (params.product_Attributes = productAttributesParam);
  const isSimilarProducts = searchParams.get("similar") === "1";
  const activeSimilarFilters = Object.entries(similarProductFilters);
  const similarFilterCategoryName = supCategory || category;

  const { data, isLoading, isError, error } = useGetProductsQuery(params);
  const { data: products, totalCount, paginationResult } = data || [];
  const {
    data: attributeValues,
    isLoading: isLoadingAttributeValues,
  } = useGetAttributesValuesQuery(
    isSimilarProducts && similarFilterCategoryName
      ? similarFilterCategoryName
      : skipToken
  );

  const { data: parentCategory, isLoading: isLoadingParent } =
    useGetparentCategoryQuery(params);
  const { data: subCategory, isLoading: isLoadingSub } =
    useGetSubCategoryQuery(params);


  useEffect(() => {
    if (isError) {
      toast.error(error?.data?.message);
    }
  }, [isError, error?.data?.message]);

  /**
   * 在现有分类筛选器中更新相似产品属性，并同步查询参数。
   * @param {Object|Function} nextOptionsOrUpdater 新筛选条件或状态更新函数
   * @returns {void}
   */
  const handleSimilarFilterOptionsChange = (nextOptionsOrUpdater) => {
    const nextFilters =
      typeof nextOptionsOrUpdater === "function"
        ? nextOptionsOrUpdater(similarProductFilters)
        : nextOptionsOrUpdater;
    const nextSearchParams = new URLSearchParams(searchParams);

    nextSearchParams.delete("page");

    if (nextFilters && Object.keys(nextFilters).length > 0) {
      nextSearchParams.set("product_Attributes", JSON.stringify(nextFilters));
    } else {
      nextSearchParams.delete("similar");
      nextSearchParams.delete("sourceProductId");
      nextSearchParams.delete("product_Attributes");
    }

    navigate(`/products?${nextSearchParams.toString()}`);
  };

  return (
    <SidebarProvider>
      <>
        <MetaData title="All-Products" />
        <main className="px-2 sm:px-[50px] md:px-[100px] bg-[#F5F9FF]">
          <CategoryNav product={{ category: subCategory?.name || parentCategory?.name }} />
          <article className="w-full min-h-[70vh] flex flex-col md:flex-row gap-12">
            <div className="hidden md:block">
              <SidebarCategory
                isLoadingSub={isLoadingSub}
                parentCategory={parentCategory}
                subCategory={subCategory}
                isLoadingParent={isLoadingParent}
              />
            </div>
            <section className="flex flex-col flex-1 shrink-0 min-w-0">
              {keyword ? (
                <>
                  <div className="flex flex-row items-center justify-between py-2">
                    <h1 id="products_heading" className="text-gray-500 text-sm font-medium">
                      {products?.length || 0} Results shown for: <span className="text-gray-700 font-bold">{keyword}</span>
                    </h1>
                  </div>
                </>
              ) : (
                <div className={keyword ? "w-1/2 md:w-3/4" : "w-1/2 md:w-full"}>
                  <h1 id="products_heading" className="text-gray-500 text-sm font-medium">
                    {keyword ? (
                      `${
                        products?.length || 0
                      } Products Found With keyword: ${keyword}`
                    ) : (
                      <BodyContent
                        subCategory={subCategory}
                        parentCategory={parentCategory}
                        isLoadingParent={isLoadingParent}
                      />
                    )}
                  </h1>
                </div>
              )}
              {isLoading && <Loader />}
              {isSimilarProducts && activeSimilarFilters.length > 0 && (
                <InlineAttributesFilter
                  setOptions={handleSimilarFilterOptionsChange}
                  selectedOptions={similarProductFilters}
                  filteredProductsCount={totalCount}
                  isLoadingValues={isLoadingAttributeValues}
                  parentAttributes={attributeValues?.data?.category}
                />
              )}
              <ResultsShownFilter
                resPerPage={paginationResult}
                filteredProductsCount={totalCount}
              />
              <ProductsTable products={products} />
              <CustomPagination
                resPerPage={paginationResult}
                filteredProductsCount={totalCount}
              />
            </section>
          </article>
        </main>
      </>
    </SidebarProvider>
  );
};

export default ProductsPage;
